export default __webpack_public_path__ + "static/media/subscription_appendix_mid_high.8883bace.jpg";